import { render } from "./setting_next.vue?vue&type=template&id=4d9c5ecc&scoped=true"
import script from "./setting_next.vue?vue&type=script&lang=js"
export * from "./setting_next.vue?vue&type=script&lang=js"

import "./setting_next.vue?vue&type=style&index=0&id=4d9c5ecc&lang=scss&scoped=true"
import "./setting_next.vue?vue&type=style&index=1&id=4d9c5ecc&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d9c5ecc"]])

export default __exports__